<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px">
      <div class="modal-header">
        <div class="title">派单</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">


        <div style="padding-left: 10px;">


          <div style="float: right;margin-right: 10px;">

            <el-input size="mini" v-model="elderlyName" placeholder="选择老人" disabled style="width: 250px;margin-right: 5px;">
              <el-button size="mini" slot="append" icon="el-icon-search" @click="showElderly"></el-button>
              <el-button size="mini" slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
            </el-input>

            <el-button size="mini" @click="showGoods">选择服务项目</el-button>

          </div>
          <div style="clear: both;"></div>

        </div>

        <div style="height: 10px;"></div>

        <el-table :data="listBeforeCartBusinessDTO" size="mini" border stripe max-height='450'>

          <el-table-column label="标题" width="200" fixed="left">
            <template slot-scope="scope">
              <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                <div :key="item.goodsName">
                  <span style="display: inline-block;margin-right: 10px;">{{item.goodsName}}</span>
                  <el-button type="text" @click="handleDelete(item.beforeCartGoodsCode)">删除</el-button>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="80">
            <template slot-scope="scope">
              <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                <div :key="item.number">
                  <span style="display: inline-block;margin-right: 10px;">{{item.number}}</span>
                  <el-button type="text" @click="handleEditNumber(item)">编辑</el-button>
                </div>
              </template>
            </template>
          </el-table-column>
<!--          <el-table-column label="单价" width="60">-->
<!--            <template slot-scope="scope">-->
<!--              <template v-for="item in scope.row.listBeforeCartGoodsDTO">-->
<!--                <div :key="item.number" >{{item.beforeCartGoodsPriceDTO.price}}</div>-->
<!--              </template>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="businessName" label="商家" width="100"></el-table-column>-->
<!--          <el-table-column prop="price" label="总价" width="80"></el-table-column>-->
<!--          <el-table-column label="类型" width="100">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.goodsType == 2">单独服务</span>-->
<!--              <span v-if="scope.row.goodsType == 3">合并服务</span>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column min-width="190" label="预约时间">
            <template slot-scope="scope">
              <span style="display: inline-block;margin-right: 10px;">{{timefilter(scope.row)}}</span>
              <el-button type="text" @click="handleEditTime(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
          <el-table-column width="160" label="服务人">
            <template slot-scope="scope">
              <span v-if="scope.row.serveCode != null" style="display: inline-block;margin-right: 10px;">{{scope.row.serveName}}</span>
              <el-button type="text" @click="handleServe(scope.row)">编辑</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="height: 10px;"></div>

        <div style="padding-left: 10px;">
          <div style="float: right;margin-right: 10px;">
            <el-button size="mini" @click="showAddress">选择地址</el-button>
          </div>
          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <el-table :data="addressInfo" size="mini" border stripe max-height='250'>
          <el-table-column prop="receiveName" label="收货人" width="150"></el-table-column>
          <el-table-column prop="receivePhone" label="手机号"></el-table-column>
          <el-table-column prop="areaNamePath" label="地区"></el-table-column>
          <el-table-column prop="receiveAddress" width="200" label="详细地址"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="showAddress(scope.$index, scope.row)">更换</el-button>
            </template>
          </el-table-column>
        </el-table>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
      </div>
    </div>

    <WriteAddress ref="myAddress" v-show="showModalAddress" v-on:closeAddress="closeAddress" v-on:setAddress="setAddress"></WriteAddress>


    <WriteElderly ref="myElderly" v-show="showModalElderly" v-on:closeElderly="closeElderly"
                  v-on:setElderly="setElderly"></WriteElderly>
    <WriteGoods ref="myGoods" v-show="showModalGoods" v-on:closeGoods="closeGoods"
                v-on:getCart="getCart"></WriteGoods>

    <WriteEditNumber ref="myEditNumber" v-show="showModalEditNumber" v-on:closeEditNumber="closeEditNumber"
                     v-on:getCart="getCart"></WriteEditNumber>
    <WriteEditTime ref="myEditTime" v-show="showModalEditTime" v-on:closeEditTime="closeEditTime"
                   v-on:getCart="getCart"></WriteEditTime>
    <WriteServe ref="myServe" v-show="showModalServe" v-on:closeServe="closeServe"
                v-on:getCart="getCart"></WriteServe>



  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import WriteAddress from "../Business/WriteAddress"
import WriteEditNumber from "../Business/WriteEditNumber"
import WriteEditTime from "../Business/WriteEditTime"

import WriteGoods from "./WriteGoodsDisable"
import WriteServe from "./WriteServe"



import WriteElderly from "@/views/Elderly/Comm/ElderlyGovClass"

export default {
  name: 'GetGood',
  data() {
    return {
      showModalCartEdit:false,
      showModalAddress:false,

      loading: false,

      showModalElderly:false,
      showModalGoods:false,
      showModalEditNumber:false,
      showModalEditTime:false,
      showModalServe:false,

      listBeforeCartBusinessDTO:[],
      addressInfo:[],
      userAddressCode:'',

      elderlyCode:'',
      elderlyName:'',


    }
  },
  components:{
    WriteAddress,WriteElderly,WriteGoods,WriteEditTime,WriteServe,WriteEditNumber
  },
  methods: {
    init(){
      this.elderlyCode = '';
      this.elderlyName = '';
      this.listBeforeCartBusinessDTO = [];
      this.addressInfo = [];
      this.userAddressCode = '';
    },
    closeSelf() {
      this.$emit("closeAdd");
    },



    showElderly(){
      this.showModalElderly = !this.showModalElderly;
      this.$refs.myElderly.init();
    },
    closeElderly:function(){
      this.showModalElderly = !this.showModalElderly;
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.elderlyName = row.name;
      this.getCart();
    },
    clearElderly:function (){
      this.elderlyCode = '';
      this.elderlyName = '';
      this.listBeforeCartBusinessDTO = [];
    },


    showGoods(){
      if(this.elderlyCode == ''){
        this.$message.info("先选择老人");
        return;
      }
      this.showModalGoods = !this.showModalGoods;
      this.$refs.myGoods.init(this.elderlyCode);
    },
    closeGoods:function(){
      this.showModalGoods = !this.showModalGoods;
    },




    handleEditNumber(item) {
      this.$refs.myEditNumber.init(item);
      this.showModalEditNumber = !this.showModalEditNumber;
    },
    closeEditNumber:function(){
      this.showModalEditNumber = !this.showModalEditNumber;
    },

    handleEditTime(row) {
      this.$refs.myEditTime.init(row);
      this.showModalEditTime = !this.showModalEditTime;
    },
    closeEditTime:function(){
      this.showModalEditTime = !this.showModalEditTime;
    },

    handleServe(row) {
      this.$refs.myServe.init(row);
      this.showModalServe = !this.showModalServe;
    },
    closeServe:function(){
      this.showModalServe = !this.showModalServe;
    },





    showAddress(){
      if(this.elderlyCode == ''){
        this.$message.info("先选择老人");
        return;
      }
      this.$refs.myAddress.init(this.elderlyCode);
      this.showModalAddress = !this.showModalAddress;
    },
    closeAddress:function(){
      this.showModalAddress = !this.showModalAddress;
    },
    setAddress(address){
      this.addressInfo=[]
      this.addressInfo.push(address);
      this.userAddressCode=address.userAddressCode
    },



    confirm(){

      if(this.elderlyCode ==''){
        this.$message.info("请选择老人");
        return;
      }
      if(this.listBeforeCartBusinessDTO==null || this.listBeforeCartBusinessDTO.length==0){
        this.$message.info("请选择商品");
        return;
      }
      if(this.userAddressCode == ''){
        this.$message.info("请选择地址");
        return;
      }

      for(let i=0;i<this.listBeforeCartBusinessDTO.length;i++){
        let item = this.listBeforeCartBusinessDTO[i];
        if(item.serveCode == null || item.serveCode == ''){
          this.$message.info("请选择服务人");
          return;
        }
      }



      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"AppCare/BeforeCartSubmitNowGov",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          userAddressCode:this.userAddressCode,
          elderlyCode:this.elderlyCode
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.closeSelf();
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },

    timefilter(row){
      return timefilters(row.planTime).substring(0,16);
    },

    getCart(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"AppCare/BeforeCart",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          elderlyCode:this.elderlyCode
        }
      }).then((response) => {
        this.loading = false;
        if(response.data.error == 0) {
          this.listBeforeCartBusinessDTO=response.data.data.beforeCartDTO.listBeforeCartBusinessDTO;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },

    handleDelete(beforeCartGoodsCode){
      this.$confirm('确定删除此商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl+"AppCare/BeforeCartItemDelete",
          data: {
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            timeStr:timeStr,
            staffCode:getStaffCode(),
            beforeCartGoodsCode:beforeCartGoodsCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getCart();
            //this.$message({type: 'success', message: '删除成功!'});
          }else if(response.data.error == 1){
            this.$message.error(response.data.message)
          }
        })

      }).catch(() => {
        //this.$message({type: 'info', message: '已取消删除'});
      });
    },


  }
}


</script>

